import type { RouteObject } from 'react-router';

import { RecoverPage } from './Recover';

/** `/recover` — one `RouteObject`, so the file is `.route.tsx` singular. */
export const recoverRoute: RouteObject = {
  path: '/recover',
  element: <RecoverPage />,
};
